module.exports = __webpack_public_path__ + "static/img/goodness3.8334d4b1.png";